import {
  ADMIN_USER_SESSIONS_PATH,
  ALL_USERS_PATH,
  GET_ALL_USERS_CSV_PATH,
  GET_ACTIVE_USERS_CSV,
  GET_PROP_FIRM_ACCOUNTS_CSV,
  GET_UNACTIVE_USERS_CSV,
  GET_USERS_WITHOUT_ACCOUNT_CSV,
} from '../../../../constants'
import AbstractService from '../../../../services/AbstractService'

import {
  GetUserSessionsRequest,
  GetUserSessionsResponse,
  GetUsersCSVResponse,
  GetUsersRequest,
  GetUsersResponse,
} from './types'

class UsersApiClass extends AbstractService {
  getAllUsers = (data: GetUsersRequest) =>
    this.request<GetUsersResponse>(ALL_USERS_PATH, 'post', false, data)
  getAllUsersCsv = (data: GetUsersRequest) =>
    this.getBlobWithFilename<GetUsersCSVResponse>({
      url: GET_ALL_USERS_CSV_PATH,
      method: 'post',
      data,
    })

  getUserSessions = (data: GetUserSessionsRequest) =>
    this.request<GetUserSessionsResponse>(ADMIN_USER_SESSIONS_PATH, 'post', false, data)

  getUsersWithoutAccountCsv = () =>
    this.getBlobWithFilename<GetUsersCSVResponse>({ url: GET_USERS_WITHOUT_ACCOUNT_CSV })

  getActiveUsersCsv = () =>
    this.getBlobWithFilename<GetUsersCSVResponse>({ url: GET_ACTIVE_USERS_CSV })

  getUnactiveUsersCsv = () =>
    this.getBlobWithFilename<GetUsersCSVResponse>({ url: GET_UNACTIVE_USERS_CSV })

  getPropFirmAccountsCsv = () =>
    this.getBlobWithFilename<GetUsersCSVResponse>({ url: GET_PROP_FIRM_ACCOUNTS_CSV })
}

export const UsersApi = new UsersApiClass()
